import gsap from 'gsap'

export const once = () => {

    let brand = document.querySelector('[data-brand]')
    let verification = document.querySelector('.age-verification')

    if (!brand || window.innerWidth < 782) return

    let logo = brand.querySelector('[data-brand-logo]'),
        wordmark = brand.querySelector('[data-brand-wordmark]')

    brand.style.opacity = 1


    let tl = gsap.timeline({ delay: 0.2 })

    tl.fromTo(brand, {
        x: '25%',
    }, {
        x: 0,
        duration: 1.4,
        ease: 'power3.inOut',
    })

    tl.fromTo(logo, {
        x: '-106%',
    }, {
        x: 0,
        duration: 1.4,
        ease: 'power3.inOut',
    }, '<')

    tl.fromTo(wordmark, {
        x: '120%',
    }, {
        x: 0,
        duration: 1.4,
        ease: 'power3.inOut',
    }, '<')

}

export default () => { }